<template>
  <common-data-table
    title="Location areas"
    newActionTitle="Add area"
    :headers="headers"
    :dataBasePath="collectionParent"
    collectionName="areas"
  >
    <template v-slot:newItemPopup="{ close, item }">
      <common-editing-popup
        :title="item ? 'Update location area' : 'New location area'"
        @close="close()"
        :canSubmit="formValid"
        :dataBasePath="collectionParent"
        collectionName="areas"
        :originalItem="item"
        :key="'location-area-edit-' + (item ? item.id : Date().toString())"
        deleteConfirmationTitle="Delete location area"
        deleteConfirmationMessage="This will permanently remove the location area from your warehouse and from any associated materials."
        :successMessage="
          item
            ? 'Area <b>{{name}}</b> successfully <b>updated</b>'
            : 'Area <b>{{name}}</b> was added successfully'
        "
      >
        <template v-slot:default="{ editedItem }">
          <v-form v-model="formValid">
            <v-container class="pa-0">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    label="Name"
                    v-model="editedItem.name"
                    :rule="[rules.required]"
                    filled
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </template>
      </common-editing-popup>
    </template>
  </common-data-table>
</template>

<script>
import { mapGetters } from 'vuex'
import CommonDataTable from '@/components/CommonDataTable.vue'
import CommonEditingPopup from '@/components/CommonEditingPopup.vue'
import { textFieldRules } from '@/common'

export default {
  components: {
    CommonDataTable,
    CommonEditingPopup,
  },
  props: {
    locationId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    formValid: false,
    rules: textFieldRules,
    headers: [
      {
        text: 'Area name',
        value: 'name',
      },
      {
        text: 'Edit',
        value: 'actions',
        sortable: false,
      },
    ],
  }),
  computed: {
    ...mapGetters(['companyId']),
    collectionParent() {
      return `companies/${this.companyId}/locations/${this.locationId}`
    },
  },
}
</script>